import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

const NewCharacters = () => {
  const navigate = useNavigate();
  const [character, setCharacter] = useState({
    character_desc: "",
    character_name: "",
    content_id: "",
    title: ""
  });
  const [selectedImage, setSelectedImage] = useState(null); // state for image
  const [imagePreview, setImagePreview] = useState(null); // state for image preview
  const [searchResults, setSearchResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  let searchTimeout = null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCharacter({ ...character, [name]: value });

    if (name === "title") {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => handleSearch(value), 300);
    }
  };

  const handleSearch = async (query) => {
    if (!query) {
      setSearchResults([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await apiService.postData("admin/search-content", { title: query });
      const data = response.data || [];
      setSearchResults(Array.isArray(data) ? data : []);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResults([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectTitle = (title, content_id) => {
    setCharacter({ ...character, title, content_id });
    setShowSuggestions(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file)); // create image preview
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const filteredCharacter = {};
    for (const key in character) {
      if (character[key]) {
        filteredCharacter[key] = character[key];
      }
    }
  
    const formData = new FormData();
    
    formData.append("import_type", "character");
  
    for (const key in filteredCharacter) {
      formData.append(key, filteredCharacter[key]);
    }
  
    if (selectedImage) {
      formData.append("files", selectedImage); // 'files' is the field name for the image
    }
  
    try {
      const response = await apiService.postData("admin/character", formData, {
        headers: { "Content-Type": "multipart/form-data" }, // Set the content type to multipart/form-data
      });
      console.log("Upload successful:", response);
      navigate("/characters");
    } catch (error) {
      console.error("Error uploading character:", error);
    }
  };
  

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>New Character</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group position-relative">
                <label>Select Content</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={character.title}
                  onChange={handleChange}
                  placeholder="Search Content"
                  autoComplete="off"
                />
                {showSuggestions && searchResults.length > 0 && (
                  <div className="list-group position-absolute w-100 mt-1" style={{ zIndex: 10 }}>
                    {searchResults.map((item) => (
                      <button
                        type="button"
                        className="list-group-item list-group-item-action"
                        key={item.content_id}
                        onClick={() => handleSelectTitle(item.title, item.content_id)}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="form-group mt-3">
                <label>Character Name</label>
                <input
                  type="text"
                  name="character_name"
                  className="form-control"
                  value={character.character_name}
                  onChange={handleChange}
                  placeholder="Enter Name"
                />
              </div>
              <div className="form-group mt-3">
                <label>Character Description</label>
                <textarea
                  name="character_desc"
                  className="form-control"
                  value={character.character_desc}
                  onChange={handleChange}
                  placeholder="Enter Description"
                ></textarea>
              </div>
              <div className="form-group mt-3">
                <label>Upload Image</label>
                <input
                  type="file"
                  name="image"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <div className="mt-2">
                    <img src={imagePreview} alt="Image Preview" style={{ maxWidth: "200px", maxHeight: "200px" }} />
                  </div>
                )}
              </div>
              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Character
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/characters")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCharacters;
